import { Field, FieldAttributes, FieldProps } from 'formik';
import { forwardRef } from 'react';
import FloatingSelect, { FloatingSelectProps } from './FloatingSelect';

interface FormikFloatingSelectProps extends FloatingSelectProps {
    fieldProps?: FieldAttributes<any>;
}

const FormikFloatingSelect = forwardRef<HTMLSelectElement, FormikFloatingSelectProps>((props, ref) => {
    const { name, id, fieldProps, invalid, ...rest } = props;

    const idOrName = id || name;

    return (
        <Field name={name} {...fieldProps}>
            {({ field, meta }: FieldProps) => (
                <FloatingSelect
                    {...rest}
                    {...field}
                    ref={ref}
                    id={idOrName}
                    name={name}
                    invalid={(meta.touched && Boolean(meta.error)) || invalid}
                />
            )}
        </Field>
    );
});

export default FormikFloatingSelect;
